

<template>
  <div class="bulletFrameWarp" :style="show?'opacity:.96' : ''">
    <div class="bulletFrameWarpLeft">
      <div class="pLogWarp">
        <img @click="openLink" :src="pInfo.avatar" alt="">
      </div>
      <div class="back" @click="close">
        <img src="../../assets/image/mobile/m_close.png" alt="">
        <div class="bText fOR">
          CLOSE
        </div>
      </div>
    </div>
    <div class="bulletFrameWarpRight">
      <div class="title fOH">{{pInfo.title || 'pInfo昵称'}} </div>
      <div class="content fOM" v-html="pInfo.desc || ''">

      </div>
    </div>
  </div>
</template>
<script>

export default {
  name:'BulletFrame',
  computed: {
    link() {
      return link
    }
  },
  props:{
    pInfo:{
      type:Object,
      default(){
        return {}
      }
    },
  },
  created() {
    setTimeout(r=>{
      this.show = true
    },100)
  },
  data(){
    return {
      show:false,
    }
  },
  methods:{
    openLink() {
      if(this.pInfo.c_url){
        try {
          window.open(this.pInfo.c_url)
        }catch (e){
          window.location.href = this.pInfo.c_url
        }
      }
    },
    close(){
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
  .bulletFrameWarp{
    position: fixed;
    top: 104px;
    left: 50%;
    transition: .5s;
    transform: translateX(-50%);
    z-index: 100;
    background: red;
    height: calc(90% - 104px);
    width: 70%;
    padding: 1rem;
    background: linear-gradient(-20deg, #185FCB 0%, #74B5D4 100%);
    border-radius: 10px;
    opacity: 0;
    display: flex;
    align-items: flex-start;
    .bulletFrameWarpRight{
      padding-top: 4.5rem;
      margin-right: 4rem;
      margin-left: 2rem;
      flex: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      box-sizing: border-box;
      .title{
        color: #fff;
        padding-bottom: 1.6rem;
        border-bottom: .07rem solid rgba(255,255,255,.7);
      }
      .content{
        padding-top: 1.6rem;
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
        color: #fff;
        font-size: .95rem;
        line-height: 1.8rem;
      }
    }
    .bulletFrameWarpLeft{
      width: 25%;
      margin-top: 4rem;
      margin-left: 4rem;
      .back{
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 2rem;
        img{
          width: 1rem;
        }
        .bText{
          color: #fff;
          font-size: .9rem;
          margin-left: .5rem;
        }
      }
      .pLogWarp{
        img{
          width: 100%;
        }
      }
    }
  }
</style>
